import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MfersTetrisLandingPage.css';

function MfersTetrisLandingPage() {
  const navigate = useNavigate();

  return (
    <div className="mferstetris-landing">
      <div className="landing-content">
        <h1 className="game-title">Mfers Tetris</h1>
        <p className="game-subtitle">Built with Rust + WebAssembly</p>

        <div className="game-description">
          <p>
            Stack the blocks, clear the lines, and rack up that score!
          </p>
          <p className="tech-note">
            This game is powered by Rust compiled to WebAssembly for
            blazing fast performance.
          </p>
        </div>

        <div className="controls-section">
          <h3>Controls</h3>
          <div className="controls-grid">
            <div className="control-item">
              <span className="key">←/→</span>
              <span>Move Left/Right</span>
            </div>
            <div className="control-item">
              <span className="key">↓</span>
              <span>Soft Drop</span>
            </div>
            <div className="control-item">
              <span className="key">↑</span>
              <span>Rotate</span>
            </div>
            <div className="control-item">
              <span className="key">Space</span>
              <span>Hard Drop</span>
            </div>
          </div>
        </div>

        <div className="button-group">
          <button
            className="play-button"
            onClick={() => navigate('/mferstetris/play')}
          >
            Play Now
          </button>
          <button
            className="back-button"
            onClick={() => navigate('/')}
          >
            Back to Arcade
          </button>
        </div>

        <div className="wasm-badge">
          Powered by 🦀 Rust + WebAssembly
        </div>
      </div>
    </div>
  );
}

export default MfersTetrisLandingPage;
